import LIST, { Collapse, Collapsible, EL, Expand, LI } from '../../../DOM/LIST/LIST.js';
import { HTMLELEMENT } from '../../../../enums/HTMLELEMENT.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { LISTTYPES } from '../../../../enums/LISTTYPES.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
// Model Structure
export const ulAttr = makeAttrStruct([
    ['class']
]);
export const ulData = makeDataStruct([
    ['children', []],
    ['type', LISTTYPES.UL]
]);
export const ulModel = makeStruct([
    ['attributes', ulAttr],
    ['data', ulData]
]);
// Simplified Model
export function ul(className, children) {
    return ulModel(ulAttr(className), ulData(children));
}
/** An Unordered List */
export default class UL extends LIST {
    constructor(node, model) {
        super(node, HTMLELEMENT.UL, model);
    }
}
export { Collapse, Collapsible, EL, Expand, LI, LIST };
